<script lang="ts">
  import Card from "../../../Core/Card.svelte";
  import  FeatherIcon from "svelte-feather-icon"
  import data from "../../../../Data/Ecommerce/Ecommerce.json"
</script>

<Card>
  <div slot="contentbody">
    <div class="collection-filter-block">
      <ul class="pro-services">
        {#each data.servicesdata.slice(0,2) as serviceItem}
          <li>
            <div class="media">
              <FeatherIcon icon={serviceItem.icon} />
              <div class="media-body">
                <h5>{serviceItem.title}</h5>
                <p>{serviceItem.subtitle}</p>
              </div>
            </div>
          </li>
        {/each}
      </ul>
    </div>
  </div>
</Card>
